import { View, Text, StyleSheet } from "react-native";
import { InputCustomNumeric } from "../InputCustomNumeric";
import { PickerFonts } from "../PickerFonts";
import { useCustomFont } from "./useCustomFont";
import { ADMIN_COLORS, ADMIN_FONT } from "../../../config/theme/adminColors";
import { FieldLabel } from "../../AdminPanel/Products/formStyles";

export const CustomFont = () => {
  const {
    fontXS,
    setFontXS,
    fontSM,
    setFontSM,
    fontMD,
    setFontMD,
    fontLG,
    setFontLG,
    fontLX,
    setFontLX,
    selectedFontTitle,
    setSelectedFontTitle,
    selectedFontSubtitle,
    setSelectedFontSubtitle,
    selectedFontText,
    setSelectedFontText,
  } = useCustomFont();

  const fontFields = [
    { label: "Títulos", value: selectedFontTitle, setValue: setSelectedFontTitle, fileType: "fontFamilyTitle" },
    { label: "Subtítulos", value: selectedFontSubtitle, setValue: setSelectedFontSubtitle, fileType: "fontFamilySubtitle" },
    { label: "Textos", value: selectedFontText, setValue: setSelectedFontText, fileType: "fontFamilyText" },
  ];

  const sizeFields = [
    { label: "Extra pequeno", value: fontXS, setValue: setFontXS },
    { label: "Pequeno", value: fontSM, setValue: setFontSM },
    { label: "Médio", value: fontMD, setValue: setFontMD },
    { label: "Grande", value: fontLG, setValue: setFontLG },
    { label: "Extra grande", value: fontLX, setValue: setFontLX },
  ];

  return (
    <>
      <FieldLabel tooltip="A fonte escolhida será visualizada somente em telas que são visíveis para o usuário final.">
        Fontes
      </FieldLabel>

      <View style={styles.fontsRow}>
        {fontFields.map((f) => (
          <View key={f.fileType} style={styles.fontCol}>
            <Text style={styles.subLabel}>{f.label}</Text>
            <PickerFonts
              selectedValue={f.value}
              setSelectValue={f.setValue}
              fileType={f.fileType}
            />
          </View>
        ))}
      </View>

      <View style={styles.divider} />

      <FieldLabel tooltip="Os tamanhos de fontes determinam a altura das letras e palavras exibidas, medidos em pixels (px).">
        Tamanho das fontes (px)
      </FieldLabel>

      <View style={styles.sizesRow}>
        {sizeFields.map((f) => (
          <View key={f.label} style={styles.sizeCell}>
            <Text style={styles.subLabel} numberOfLines={1}>{f.label}</Text>
            <InputCustomNumeric
              value={f.value}
              onChangeText={(text) => f.setValue(Number(text.replace(/[^0-9]/g, "")))}
            />
          </View>
        ))}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  fontsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
    marginTop: 8,
    marginBottom: 4,
  },
  fontCol: {
    flex: 1,
    minWidth: 160,
  },
  subLabel: {
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    fontWeight: "600",
    color: ADMIN_COLORS.label,
    marginBottom: 6,
  },
  divider: {
    height: 1,
    backgroundColor: ADMIN_COLORS.border,
    marginVertical: 18,
  },
  sizesRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 8,
  },
  sizeCell: {
    flex: 1,
    minWidth: 92,
  },
});
